// client/src/index.jsx
// ---------------------------------
// Entry point
// ---------------------------------
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/main.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);